import { createSearchFilter } from 'components/tables/common/filters/createSearchFilter';
import { createSelectionTable } from 'components/tables/selection/createSelectionTable';
import { closeModal, openModal } from './baseModal/baseModal';
import { controlBar } from 'courthive-components';
import { context } from 'services/context';

import { LEFT } from 'constants/tmxConstants';
import { t } from 'i18n';

/*
 * assumes that all options have their own .onClick method
 */
export function selectItem(params) {
  const { title, placeholder, options, selectionLimit } = params;
  const controlId = 'selectionControl';
  const anchorId = 'selectionTable';
  const buttons = [{ label: t('common.cancel'), intent: 'none', close: true }];
  const onClose = () => {
    const table = context.tables['selectionTable'];
    table?.destroy();

    delete context.tables['selectionTable'];
  };
  const content = `
    <div style='min-height: 420px'>
      <div id='${controlId}'></div>
      <div id='${anchorId}'></div>
    </div>
  `;

  openModal({ title, content, buttons, onClose });

  const onSelected = (value) => {
    if (value?.[0]?.onClick) {
      value[0].onClick();
      closeModal();
    }
  };
  const { table } = createSelectionTable({
    targetAttribute: 'participantid',
    selectionLimit,
    data: options,
    placeholder,
    onSelected,
    anchorId,
  });

  const setSearchFilter = createSearchFilter(table);
  const items = [
    {
      onKeyDown: (e) => e.keyCode === 8 && e.target.value.length === 1 && setSearchFilter(''),
      onChange: (e) => setSearchFilter(e.target.value),
      onKeyUp: (e) => setSearchFilter(e.target.value),
      clearSearch: () => setSearchFilter(''),
      placeholder: t('settings.search'),
      location: LEFT,
      search: true,
    },
  ];

  const target = document.getElementById(controlId) || undefined;
  controlBar({ table, target, items });
}
